"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var page_header_footer_init_service_1 = require("./page-header-footer-init-service");
(function (angularModule) {
    angularModule.directive('prPageHeaderFooter', [
        '$sanitize',
        'prEventService',
        'prHeaderFooterService',
        'prPageHeaderFooterModal',
        'prPageHeaderFooterExportLoadingService',
        '$timeout',
        function ($sanitize, eventService, headerFooterService, headerFooterModal, pageHeaderFooterExportMap, $timeout) {
            var PAGE_VARIABLE = '{{__page__}}';
            var HEADER_FOOTER_RENDER_DELAY = 1000;
            var pageNumber = 0;
            return {
                scope: false,
                link: function ($scope, $element) {
                    pageNumber += 1;
                    pageHeaderFooterExportMap.setStartLoading(pageNumber);
                    var type = $element.attr('type');
                    updateContent(pageNumber);
                    if (!$scope.$ctrl.isPublic) {
                        // no clicking interactions in public reports
                        $element.on('dblclick', showOptions);
                    }
                    eventService.on(type + 'ConfigChanged', updateContent);
                    function updateContent(pageNum) {
                        var headerOrFooterProperties = headerFooterService.getProperty(type);
                        var content = '';
                        if (!headerFooterService.isDisabled(headerOrFooterProperties)) {
                            content = lodash_1.default.replace(headerOrFooterProperties.html, PAGE_VARIABLE, $scope.$ctrl.pageNumber + 1);
                        }
                        $element.html(content);
                        // apply the height which has been rounded to cell size
                        $element.css('height', headerFooterService.getPXHeight(type));
                        // This fixes a race condition that causes exports to
                        // have missing page numbers when no widgets are on a page.
                        // Use a $timeout to ensure the css is rendered.
                        $timeout(function () {
                            if (!pageHeaderFooterExportMap.isDoneLoading() && pageNum !== undefined) {
                                pageHeaderFooterExportMap.setFinishLoading(pageNum);
                            }
                            if (pageHeaderFooterExportMap.isDoneLoading()) {
                                eventService.trigger(page_header_footer_init_service_1.HEADER_FOOTER_RECALC_TRIGGER.headerFooterRendered);
                            }
                        }, HEADER_FOOTER_RENDER_DELAY);
                    }
                    function showOptions() {
                        headerFooterModal.show(type);
                    }
                }
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
